import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import * as _ from 'lodash-es';
import { withIntl, propTypes as intlPropTypes } from 'ha/i18n';
import { changeLocation } from 'ha/modules/URLLocationHandler';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';
import { normalizeApiV2Errors } from 'ha/utils/reduxForm';
import { loginRequest, registerRequest } from './actions';
import { getIsLoading } from './selectors';

export class AuthLogic extends Component {
  onAuthenticate = _.memoize(authType => nextUrl => fields =>
    this.props[authType](fields, nextUrl)
      .then(() => {
        this.props.hideAuthModal();
      })
      .catch(err =>
        Promise.reject(normalizeApiV2Errors(this.props.intl.T, err)),
      ),
  );

  render() {
    return this.props.children(
      this.onAuthenticate('login'),
      this.onAuthenticate('register'),
      this.props.isLoading,
    );
  }
}

AuthLogic.propTypes = {
  children: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  hideAuthModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  changeLocation: PropTypes.func.isRequired,
  intl: intlPropTypes.isRequired,
};

export default compose(
  connect(
    state => ({
      isLoading: getIsLoading(state),
    }),
    {
      login: loginRequest,
      register: registerRequest,
      changeLocation,
      hideAuthModal: NavBarActions.hideModal,
    },
  ),
  withIntl,
)(AuthLogic);
